import { useState } from 'react'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import { reExportedColors, Text } from '../../1elements'
import { texts } from '../../../consts/Texts'
import ImageUploadButton from '../../1elements/Buttons/TextButtons/ImageUploadButton/ImageUploadButton'
import useImageUpload from '../../../services/customHooks/useImageUpload'

const ImageUploader = ({ className, setImageFile, sx }) => {
  const theme = useTheme()
  const [error, setError] = useState('')
  const { getRootProps, getInputProps, open } = useImageUpload(
    setImageFile,
    2000 * 1000,
    setError
  )
  const instructionStyle = {
    color: theme.palette.tertiary.accent,
    textAlign: 'center'
  }

  return (
    <Box
      {...getRootProps()}
      className={className}
      sx={[
        {
          alignItems: 'center',
          background: theme.palette.quaternary.accent,
          backgroundColor: reExportedColors.LIGHT_GREY,
          border: `1px dashed ${theme.palette.primary.main}`,
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center',
          padding: '20px',
          width: '100%'
        },
        ...(sx ? (Array.isArray(sx) ? sx : [sx]) : [])
      ]}
    >
      <Box sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        height: '120px',
        justifyContent: 'space-between',
        width: '200px'
      }}>
        <input {...getInputProps()} />
        <Text type='h9' style={instructionStyle}>
          {texts.imageUploader.instruction}
        </Text>
        <Text type='h6' style={instructionStyle}>{texts.or}</Text>
        <ImageUploadButton onClick={open} />
        <Text type='h6' style={instructionStyle}>
          {texts.imageUploader.finePrint}
        </Text>
        <Text type='h6' style={{ color: reExportedColors.RED }}>{error}</Text>
      </Box>
    </Box>
  )
}

export default ImageUploader
